module.exports = __webpack_public_path__ + "static/media/BOTON WEB_Instr de viento RO.63350ab4.png";